import type { CustomCellRendererProps } from '@mint-lib/ag-grid/react';

import { LoadingCell } from '@mint-lib/ag-grid/components';
import { CurrencyCodeType } from '@mint-lib/currencies-helpers';
import { useCurrencyFormatter } from '@mint-lib/formatting-hooks';

import { LOADING_STATE } from '../../../../consts/flights.js';
import { EMPTY_CELL_VALUE } from '../../../../consts/grid.consts.jsx';
import { FLIGHT_TOTAL_ROW_ID } from '../../../../types/flights.types.js';

type FlightBudgetRendererProps = CustomCellRendererProps & {
  currency?: CurrencyCodeType;
};

export const FlightBudgetRenderer = (params: FlightBudgetRendererProps) => {
  const { currency } = params;

  const currencyFormatter = useCurrencyFormatter();

  const isCellLoading = params.data.id === LOADING_STATE;
  const isTotalsLoading =
    params.data.id === FLIGHT_TOTAL_ROW_ID && params.value === LOADING_STATE;

  if (isCellLoading || isTotalsLoading) {
    return <LoadingCell />;
  }

  if (!currency) {
    return EMPTY_CELL_VALUE;
  }

  const formattedValue = currencyFormatter.format(params.value ?? '0', {
    currency,
  })?.formatted;

  return <span>{formattedValue}</span>;
};
